import React, {useEffect, useState} from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import moment from "moment";
import {Button, Col, Row} from "antd";
import {KeyConstant} from "../../../can/weighing-slip/constant/keyConstant";
import {LeftOutlined} from "@ant-design/icons";
import {Tabs} from "antd-mobile";
import {KeyConstantTab} from "../constant/keyConstantTab";
import RenderKeyDate from "../render/RenderKeyDate";
import RenderKeyWeek from "../render/RenderKeyWeek";
import RenderKeyMonth from "../render/RenderKeyMonth";
import RenderKeyCustom from "../render/RenderKeyCustom";
import RenderKeyCompare from "../render/RenderKeyCompare";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {onReloadData} from "../../../../redux/actions/layout/interaction/action";

const CalendarModalDate = ({onCancel, destroy, onDestroy, onData, onCancelTemp}) => {

    const [searchParams] = useSearchParams()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const [selectedDateRange, setSelectedDateRange] = useState({
        startDate: moment().subtract(28, "days"),
        endDate: moment().subtract(1, "days"),
    });
    const [compare, setCompare] = useState(false)
    const [compareType, setCompareType] = useState("previousPeriod")
    const [type, setType] = useState(KeyConstant.THIRTY_DAYS_AGO)
    const [tab, setTab] = useState(KeyConstantTab.MONTH.key)

    const [selectedDateRangeTemp, setSelectedDateRangeTemp] = useState({
        startDate: moment().subtract(28, "days"),
        endDate: moment().subtract(1, "days"),
    });
    const [compareTemp, setCompareTemp] = useState(false)
    const [compareTypeTemp, setCompareTypeTemp] = useState("previousPeriod")
    const [typeTemp, setTypeTemp] = useState(KeyConstant.THIRTY_DAYS_AGO)
    const [tabTemp, setTabTemp] = useState(KeyConstantTab.MONTH.key)

    useEffect(()=>{

        let range = {
            startDate: searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
                moment().subtract(28, "days").toDate(),
            endDate: searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
                moment().subtract(1, "days").toDate(),
            key: "selection"
        }
        setSelectedDateRange(range)
        setCompare(searchParams.get("compare") ? searchParams.get("compare") : false)
        setCompareType(searchParams.get("compareType") ? searchParams.get("compareType") : "previousPeriod" )
        setType(searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO )
        setTab(searchParams.get("tab") ? searchParams.get("tab") : KeyConstantTab.MONTH.key)

        setSelectedDateRangeTemp({
            startDate: searchParams.get("startDate") ? moment(searchParams.get("startDate")).toDate() :
                moment().subtract(28, "days").toDate(),
            endDate: searchParams.get("endDate") ? moment(searchParams.get("endDate")).toDate() :
                moment().subtract(1, "days").toDate(),
            key: "selection"
        })
        setCompareTemp(searchParams.get("compare") ? searchParams.get("compare") : false)
        setCompareTypeTemp(searchParams.get("compareType") ? searchParams.get("compareType") : "previousPeriod" )
        setTypeTemp(searchParams.get("type") ? searchParams.get("type") : KeyConstant.THIRTY_DAYS_AGO )
        setTabTemp(searchParams.get("tab") ? searchParams.get("tab") : KeyConstantTab.MONTH.key)

    },[searchParams])

    const handleSelect = data => {
        setType(data.key)
        setSelectedDateRange({
            startDate: data.startDate,
            endDate: data.endDate,
        });
    };

    const submit = () => {
        let object = {
            startDate: selectedDateRange.startDate,
            endDate: selectedDateRange.endDate,
            type: type,
            compare: compare,
            compareType: compareType
        }

        onData(object)

        setSelectedDateRangeTemp(selectedDateRange)
        setCompareTemp(compare)
        setCompareTypeTemp(compareType)
        setTypeTemp(type)
        setTabTemp(tab)

        searchParams.delete("startDate")
        if (selectedDateRange.startDate) {
            searchParams.append("startDate", selectedDateRange.startDate)
        }

        searchParams.delete("endDate")
        if (selectedDateRange.endDate) {
            searchParams.append("endDate", selectedDateRange.endDate)
        }
        searchParams.delete("type")
        if (type) {
            searchParams.append("type", type)
        }
        searchParams.delete("compare")
        if (compare) {
            searchParams.append("compare", compare)
        }
        searchParams.delete("compareType")
        if (compareType) {
            searchParams.append("compareType", compareType)
        }
        searchParams.delete("tab")
        if (tab){
            searchParams.append("tab", tab)
        }

        navigate(`?${searchParams.toString()}`)

        dispatch(onReloadData(!reloadData))

        onCancel()
    }

    const convert = () => {
        setSelectedDateRange(selectedDateRangeTemp)
        setCompare(compareTemp)
        setCompareType(compareTypeTemp)
        setType(typeTemp)
        setTab(tabTemp)
    }

    useEffect(() => {
        if (destroy) {
            convert()
            onDestroy()
            onCancel()
        }
    }, [destroy])

    const mapContent = () => {

        switch (tab) {
            case KeyConstantTab.DATE.key:
                return <RenderKeyDate type={type} handleSelect={handleSelect}/>
            case KeyConstantTab.WEEK.key:
                return <RenderKeyWeek type={type} handleSelect={handleSelect}/>
            case KeyConstantTab.MONTH.key:
                return <RenderKeyMonth type={type} handleSelect={handleSelect}/>
            case KeyConstantTab.CUSTOM.key:
                return <RenderKeyCustom type={type} handleSelect={handleSelect}/>
            default:
                return null
        }
    }

    return (
        <>

            <div className={"text-center p-3 opacity-80 text-black"} id={"title_h2"}>
                <Row className={"items-center"}>
                    <Col span={2}>
                        <LeftOutlined style={{fontSize: 14}}
                                      onClick={() => {
                                          onCancelTemp()
                                      }}/>
                    </Col>
                    <Col span={18}>
                        Phạm vi ngày
                    </Col>
                    <Col span={4}>
                        <Button type={"link"}
                                className={"font-semibold"} onClick={()=>submit()}> Lưu </Button>
                    </Col>
                </Row>
            </div>

            <Tabs
                activeKey={tab}
                onChange={(e) => {
                    setType(KeyConstantTab[e.toUpperCase()].type)
                    setSelectedDateRange({
                        startDate: KeyConstantTab[e.toUpperCase()].startDate,
                        endDate: KeyConstantTab[e.toUpperCase()].endDate,
                    })
                    setTab(e)
                }}
                style={{"--title-font-size": 14}}
            >
                <Tabs.Tab title={KeyConstantTab.DATE.title}
                          key={KeyConstantTab.DATE.key}/>
                <Tabs.Tab title={KeyConstantTab.WEEK.title}
                          key={KeyConstantTab.WEEK.key}/>
                <Tabs.Tab title={KeyConstantTab.MONTH.title}
                          key={KeyConstantTab.MONTH.key}/>
                <Tabs.Tab title={KeyConstantTab.CUSTOM.title}
                          key={KeyConstantTab.CUSTOM.key}/>
            </Tabs>

            {
                mapContent()
            }

            <RenderKeyCompare compare={compare}
                              setCompare={(val)=>setCompare(val)}
                              setCompareType={(val)=>setCompareType(val)}
                              compareType={compareType}
                              type={type}
                              selectedDateRange={selectedDateRange}/>

        </>
    )
}

export default CalendarModalDate
